// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__thE16","importantInfo":"styles_importantInfo__qzShz"};